import React from "react";

const ShippingPolicy = () => {
  return (
    <div className="shipping-policy-area space">
      <div className="container">
        <h4 className="mb-4">Shipping Policy</h4>
        <p>
          Gowrisankar Agencies ensures reliable delivery of auto parts across India. Below are our shipping terms.
        </p>

        <h6>1. Delivery Timelines</h6>
        <p>
          Orders are processed within 1–2 business days. Estimated delivery takes 5–10 business days depending on the location.
        </p>

        <h6>2. Shipping Charges</h6>
        <p>
          Shipping charges vary based on weight, size, and delivery location. Charges will be displayed during checkout.
        </p>

        <h6>3. Tracking Orders</h6>
        <p>
          Once your order is shipped, you’ll receive a tracking ID to monitor the delivery status.
        </p>

        <h6>4. Delays</h6>
        <p>
          While we aim for timely delivery, delays may occur due to logistics or weather. We appreciate your patience.
        </p>

        <h6>5. Contact</h6>
        <p>
          For shipping-related questions, email us at <a href="mailto:rajesh.katakam@gmail.com">rajesh.katakam@gmail.com</a> or call <a href="tel:09248022760">092480 22760</a>.
        </p>
      </div>
    </div>
  );
};

export default ShippingPolicy;
